export const routesUrl = {
  login: '/',
  dashboard: '/sync',
  categories: '/sync/category/categories',
  attributes: '/sync/category/attributes',
  products: '/sync/category/products',
  orders: '/sync/orders',
  stocks: '/sync/category/stock',
  settings: '/settings',
  guide: '/guide',
};
